export default "__VITE_ASSET__BW3KT6T0__"